import { useEffect, useRef, useState } from 'react'

export interface TimeLeft {
  hours: string
  minutes: string
  seconds: string
  isOver: boolean
}

const pad = (value: number): string => String(Math.max(0, value)).padStart(2, '0')

export function useCountdown(durationHours: number): TimeLeft {
  const deadline = useRef<number>(Date.now() + durationHours * 60 * 60 * 1000)
  const [remaining, setRemaining] = useState<number>(deadline.current - Date.now())

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(deadline.current - Date.now())
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  const clamped = Math.max(0, remaining)
  const totalSeconds = Math.floor(clamped / 1000)

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
    isOver: clamped === 0,
  }
}
